import { createBrowserRouter, Navigate } from "react-router-dom";
import { AdminLocaleLayout } from "./locale";
import { ProtectedLayout } from "./ProtectedLayout";
import { adminRoutes } from "../modules/admins/routes";
import { appConfigRoutes } from "../modules/app-configs/routes";
import { featureFlagRoutes } from "../modules/feature-flags/routes";
import { areaRoutes } from "../modules/areas/routes";
import { authRoutes } from "../modules/auth/routes";
import { dashboardRoutes } from "../modules/dashboard/routes";
import { integrationSimulatorRoutes } from "../modules/integration-simulator/routes";
import { integrationLogRoutes } from "../modules/integration-logs/routes";
import { profileRoutes } from "../modules/profile/routes";
import { sellerRoutes } from "../modules/sellers/routes";
import { storeRoutes } from "../modules/stores/routes";
import { subscriptionRoutes } from "../modules/subscriptions/routes";
import { themeRoutes } from "../modules/themes/routes";

import { whatsappRoutes } from "../modules/whatsapp/routes";
import { paidServicesRoutes } from "../modules/paid-services/routes";
import { NotFoundPage } from "../shared/layout/SystemStates";

export const adminRouter = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/ar/admin/login" replace />,
  },
  {
    path: "/:locale",
    element: <AdminLocaleLayout />,
    children: [
      ...authRoutes,
      {
        path: "admin",
        element: <ProtectedLayout />,
        children: [
          ...dashboardRoutes,
          ...profileRoutes,
          ...sellerRoutes,
          ...themeRoutes,
          ...adminRoutes,
          ...appConfigRoutes,
          ...featureFlagRoutes,
          ...areaRoutes,
          ...storeRoutes,
          ...subscriptionRoutes,
          ...integrationLogRoutes,
          ...integrationSimulatorRoutes,
          ...whatsappRoutes,
          ...paidServicesRoutes,
          // Any other admin address: the shell's 404 board, not a silent redirect.
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/ar/admin/login" replace />,
  },
]);
